import { render, staticRenderFns } from "./diedMessage.vue?vue&type=template&id=a973a338&scoped=true&"
import script from "./diedMessage.vue?vue&type=script&lang=js&"
export * from "./diedMessage.vue?vue&type=script&lang=js&"
import style0 from "./diedMessage.vue?vue&type=style&index=0&id=a973a338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973a338",
  null
  
)

export default component.exports